module.exports = __webpack_public_path__ + "img/Pista_1230.f1deb308.png";